export default (style, name) => style.getPropertyValue(name).trim();
